import { render, staticRenderFns } from "./BoxingInvoiceDetailDialog.vue?vue&type=template&id=3c671ccc&"
import script from "./BoxingInvoiceDetailDialog.vue?vue&type=script&lang=js&"
export * from "./BoxingInvoiceDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports